<template>
  <TheBaseGrid :showEditor="true" editorHeight="230px" @next="checkInput">

    <template slot="intro">
      <h2>Opgave 6</h2>
      <h3>Border</h3>
      <p>Lav en border rundt om overskriftens på 10px, du skal bruge <span class="tool" id="exButton2">border</span>.</p>
      <b-tooltip target="exButton2" placement="bottom">
        <strong>border eks:</strong><br>
        1px solid green<br>
        1px dashed blue<br>
        1px dotted yellow
      </b-tooltip>
    </template>

    <template slot="cssInput">
      <pre class="before">h1 {
    {{season[0].episode[$route.params.episodeNumber-6].cssInput}}
    {{season[0].episode[$route.params.episodeNumber-5].cssInput}}
    {{season[0].episode[$route.params.episodeNumber-4].cssInput}}
    {{season[0].episode[$route.params.episodeNumber-3].cssInput}}
    {{season[0].episode[$route.params.episodeNumber-2].cssInput}}</pre>
      <textarea class="code-box__editor"
      v-model="season[0].episode[$route.params.episodeNumber-1].cssInput"
      style="height:24px" @keydown.prevent.enter="checkInput()" autofocus></textarea>
      <pre class="after">}</pre>
    </template>

    <template slot="output">
      <h1
      :style="showStyle">Hello world</h1>
    </template>

  </TheBaseGrid>
</template>

<script>
import { mapState } from 'vuex';
import TheBaseGrid from '@/components/TheBaseGrid.vue'
export default {
  name: 'episode6',
  components: {
    TheBaseGrid
  },
  computed: {
    ...mapState([
      'season'
    ]),
    showStyle (){
     let f = this.season[0].episode[this.$route.params.episodeNumber-6].cssInput
     let e = this.season[0].episode[this.$route.params.episodeNumber-5].cssInput
     let d = this.season[0].episode[this.$route.params.episodeNumber-4].cssInput
     let c = this.season[0].episode[this.$route.params.episodeNumber-3].cssInput
     let b = this.season[0].episode[this.$route.params.episodeNumber-2].cssInput
     let a = this.season[0].episode[this.$route.params.episodeNumber-1].cssInput
     return f+e+d+c+b+a
    }
  },
  methods: {
    checkInput(){
      let string = this.season[0].episode[this.$route.params.episodeNumber-1].cssInput
      if(string){
        if (!string.includes(';')) {
           alert("husk at afslut koden med semi kolon");
           return true
        }
        if(window.getComputedStyle(document.querySelector('h1')).borderBottomStyle === 'none'){
          alert("Du har en fejl i din kode prøv igen");
        }else{
          this.$router.push({ path: '/season/1/episode/7' })

        }
      }else{
        alert("Du skal indtaste koden i den hvide boks");
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
h1{
  background-color: #fff;
}

</style>
